module.exports = __webpack_public_path__ + "img/page1-2.fc0ed996.png";